import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FaExternalLinkAlt, FaSignOutAlt } from 'react-icons/fa';

function AdminHeader() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <header className="admin-header">
      <div className="admin-header-brand">
        <span className="logo-dot" />
        RIVE Admin
      </div>
      <div className="admin-header-actions">
        <a href="/" className="site-link" target="_blank" rel="noopener noreferrer">
          <FaExternalLinkAlt /> Voir le site
        </a>
        <button onClick={handleLogout} className="logout-btn">
          <FaSignOutAlt /> Déconnexion
        </button>
      </div>
    </header>
  );
}

export default AdminHeader;
